import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NeoButton from '../../../../components/Common/NeoButton';
import NeoInput from '../../../../components/Common/NeoInput';

const DragWaitingModal = ({ isOpen, toggle, onConfirm, onCancel, itemName }) => {
    const [selectedOutcome, setSelectedOutcome] = useState('callback_later');
    const [followUpDate, setFollowUpDate] = useState('');

    const outcomes = [
        { value: 'callback_later', label: 'Vai pensar / Retornar Depois', icon: 'mdi-phone-return-outline' },
        { value: 'asked_deadline', label: 'Pediu prazo para pagar', icon: 'mdi-clock-outline' },
        { value: 'scheduled_visit', label: 'Agendou visita / Aula experimental', icon: 'mdi-calendar-check' },
        { value: 'requested_discount', label: 'Pediu desconto, aguardando decisão', icon: 'mdi-tag-outline' },
    ];

    const handleConfirm = () => {
        onConfirm({ outcome: selectedOutcome, followUpDate });
        // Limpar estados para próximo uso
        setSelectedOutcome('callback_later');
        setFollowUpDate('');
    };

    const handleCancel = () => {
        onCancel();
        setSelectedOutcome('callback_later');
        setFollowUpDate('');
    };

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={handleCancel} 
            centered 
            className="neo-modal-premium"
            style={{ fontFamily: 'Outfit, sans-serif' }}
        >
            <ModalHeader toggle={handleCancel} className="border-bottom-0 pb-1">
                <span className="fw-bold text-brand-primary font-size-16 neo-font-outfit">
                    <i className="mdi mdi-clock-time-four-outline me-2 text-accent"></i>
                    O que foi combinado com {itemName || 'o cliente'}?
                </span>
            </ModalHeader>
            <ModalBody className="py-2">
                <p className="text-muted font-size-13 mb-3">
                    Selecione um resultado de contato para mover este card para <strong>Aguardando Retorno</strong>.
                </p>

                <div className="d-flex flex-column gap-2 mb-4">
                    {outcomes.map((item) => {
                        const isSelected = selectedOutcome === item.value;
                        return (
                            <div
                                key={item.value}
                                onClick={() => setSelectedOutcome(item.value)}
                                className={`d-flex align-items-center justify-content-between p-3 border rounded-3 transition-all`}
                                style={{ 
                                    cursor: 'pointer',
                                    borderColor: isSelected ? '#482712' : 'rgba(72, 39, 18, 0.12)',
                                    backgroundColor: isSelected ? '#fef5ef' : '#ffffff',
                                    borderWidth: '2px',
                                    boxShadow: isSelected ? '0 4px 12px rgba(72, 39, 18, 0.05)' : 'none'
                                }}
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <div 
                                        className="d-flex align-items-center justify-content-center rounded-circle border" 
                                        style={{ 
                                            width: '18px', 
                                            height: '18px', 
                                            borderColor: isSelected ? '#e2661c' : '#ccd2da',
                                            borderWidth: '2px',
                                            background: '#ffffff'
                                        }}
                                    >
                                        {isSelected && (
                                            <div 
                                                className="rounded-circle" 
                                                style={{ width: '8px', height: '8px', background: '#e2661c' }} 
                                            />
                                        )}
                                    </div>
                                    <span className={`font-size-13 fw-bold ${isSelected ? 'text-brand-primary' : 'text-brand-secondary'}`}>
                                        {item.label}
                                    </span>
                                </div>
                                <i className={`mdi ${item.icon} font-size-18 ${isSelected ? 'text-accent' : 'text-muted'}`}></i>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-3">
                    <NeoInput
                        type="date"
                        label="Data de retorno (opcional)"
                        value={followUpDate}
                        onChange={(e) => setFollowUpDate(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                    />
                </div>
            </ModalBody>
            <ModalFooter className="border-top-0 pt-0 d-flex justify-content-end gap-2">
                <NeoButton 
                    variant="outline-secondary" 
                    onClick={handleCancel}
                >
                    Cancelar
                </NeoButton>
                <NeoButton 
                    variant="primary" 
                    onClick={handleConfirm}
                >
                    Confirmar e Mover →
                </NeoButton>
            </ModalFooter>
        </Modal>
    );
};

export default DragWaitingModal;
